import homePage from './routes/home_page/Homepage.vue';
import createHomePage from './routes/home_page/component/createHomePage.vue';
import editHomePage from './routes/home_page/component/editHomePage.vue';

import Article from './routes/article/Article.vue';
import createArticleNew from './routes/article/routes/createArticleNew.vue';
import editArticleNew from './routes/article/routes/editArticleNew.vue';
import previewArticle from './routes/article/routes/previewArticle.vue';

import Click2buy from './routes/click2buy/Click2buy.vue';
import formClick2buy from './routes/click2buy/routes/formClick2buy.vue';

import FaqCategory from './routes/faq/FaqCategory.vue';
import FaqContent from './routes/faq/FaqContent.vue';
import createFaq from './routes/faq/routes/createFaq.vue';
import editFaq from './routes/faq/routes/editFaq.vue';
import createFaqCategory from './routes/faq/routes/createFaqCategory.vue';
import editFaqCategory from './routes/faq/routes/editFaqCategory.vue';

import Tnc from './routes/tnc/Tnc.vue';
import TncRoutes from './routes/tnc/router.js';

import Locker from './routes/locker_microsite/Locker.vue';
import LockerRoutes from './routes/locker_microsite/router.js';

import Aboutus from './routes/aboutus/Aboutus.vue';
import aboutUsRoutes from './routes/aboutus/router.js';

import PaxelinClub from './routes/paxelin_club/PaxelinClub.vue';
import PaxelinClubRoutes from './routes/paxelin_club/router.js';

import PaxelinMarket from './routes/paxel_market/PaxelinMarket.vue';
import PaxelinMarketRoutes from './routes/paxel_market/router.js';

import Captcha from './routes/captcha/Captcha.vue';
import createCaptcha from './routes/captcha/component/createCaptcha.vue';
import editCaptcha from './routes/captcha/component/editCaptcha.vue';

import Privacypolicy from './routes/privacypolicy/Privacypolicy.vue';
import createPrivacypolicy from './routes/privacypolicy/component/createPrivacypolicy.vue';
import editPrivacypolicy from './routes/privacypolicy/component/editPrivacypolicy.vue';

import newUserPromo from './routes/newuserpromo/newUserPromo.vue';
import createnewUserPromo from './routes/newuserpromo/component/createnewUserPromo.vue';
import editnewUserPromo from './routes/newuserpromo/component/editnewUserPromo.vue';

import onBoardingScreen from './routes/onboardingscreen/onBoardingScreen.vue';
import createonBoardingScreen from './routes/onboardingscreen/component/createonBoardingScreen.vue';
import editonBoardingScreen from './routes/onboardingscreen/component/editonBoardingScreen.vue';

import ShowCase from './routes/showcase/ShowCase.vue';
import createShowCase from './routes/showcase/component/createShowCase.vue';
import editShowCase from './routes/showcase/component/editShowCase.vue';

// import ProductMaster from './routes/paxel_market/ProductMaster.vue';
// import createProductMaster from './routes/paxel_market/component/product_master/createProductMaster.vue';
// import editProductMaster from './routes/paxel_market/component/product_master/editProductMaster.vue';

// import CategoryProduct from './routes/paxel_market/CategoryProduct.vue';
// import createCategory from './routes/paxel_market/component/category/createCategory.vue';
// import editCategory from './routes/paxel_market/component/category/editCategory.vue';

// import SubCategoryProduct from './routes/paxel_market/SubCategoryProduct.vue';
// import createSubCategory from './routes/paxel_market/component/sub_category/createSubCategory.vue';
// import editSubCategory from './routes/paxel_market/component/sub_category/editSubCategory.vue';

import Donasi from './routes/donasi/Donasi.vue';
import createDonasi from './routes/donasi/component/createDonasi.vue';
import editDonasi from './routes/donasi/component/editDonasi.vue';

import ReportRating from './routes/rating/Report.vue';

import Rate from './routes/rating/Rate.vue';
import createRate from './routes/rating/routes/createRate.vue';
import editRate from './routes/rating/routes/editRate.vue';

import Reason from './routes/rating/Reason.vue';
import createReason from './routes/rating/routes/createReason.vue';
import editReason from './routes/rating/routes/editReason.vue';

import ReportRefferal from './routes/report_refferal/ReportRefferal.vue';

import GeneralContactUs from './routes/general_settings/ContactUs.vue';
import createGeneralContactUs from './routes/general_settings/component/ContactUsCreate.vue';
import editGeneralContactUs from './routes/general_settings/component/ContactUsEdit.vue';

import GeneralEnableDisableFeature from './routes/general_settings/EnableDisableFeature.vue';
import createGeneralEnableDisableFeature from './routes/general_settings/component/EnableDisableFeatureCreate.vue';
import editGeneralEnableDisableFeature from './routes/general_settings/component/EnableDisableFeatureEdit.vue';

import GeneralNewUserPromo from './routes/general_settings/NewUser.vue';
import createGeneralNewUserPromo from './routes/general_settings/component/NewUserCreate.vue';
import editGeneralNewUserPromo from './routes/general_settings/component/NewUserEdit.vue';

import ExtraPackaging from './routes/extrapackaging/ExtraPackaging.vue';
import createExtraPackaging from './routes/extrapackaging/component/createExtraPackaging.vue';
import editExtraPackaging from './routes/extrapackaging/component/editExtraPackaging.vue';

import refferalPartner from './routes/refferalpartner/refferalPartner.vue';
import createrefferalPartner from './routes/refferalpartner/component/createrefferalPartner.vue';
import editrefferalPartner from './routes/refferalpartner/component/editrefferalPartner.vue';

import corpSales from './routes/corp_sales/corpSales.vue';
import CorpSalesRoutes from './routes/corp_sales/router.js';

import PaxelcoDashboard from './routes/dashboard/PaxelcoDashboard.vue';
import footNote from './routes/footnote/footNote.vue';

import PaxelBig from './routes/paxel_big/PaxelBig.vue';
import PaxelBigRoutes from './routes/paxel_big/router.js';

import MitraPaxel from './routes/mitra_paxel/MitraPaxel.vue';
import MitraPaxelRoutes from './routes/mitra_paxel/router.js';

import OurService from './routes/our_service/OurService.vue';
import ourServiceRoutes from './routes/our_service/router.js';

import Download from './routes/download/Download.vue';
import downloadRoutes from './routes/download/router.js';

import PaxelRecycle from './routes/paxel_recycle/PaxelRecycle.vue';
import PaxelRecycleRoutes from './routes/paxel_recycle/router.js';
import PejuangOnline from './routes/pejuang_online/PejuangOnline.vue';
import PejuangOnlineRoutes from './routes/pejuang_online/router.js';

import GlobalSearch from './routes/global_search/GlobalSearch.vue';
import createGlobalSearch from './routes/global_search/component/createGlobalSearch';
import editGlobalSearch from './routes/global_search/component/editGlobalSearch';

import Promo from './routes/promo/Promo.vue';
import PromoRoutes from './routes/promo/router.js';

const marketingRoutes = [
  {
    path: '/our-service',
    name: 'OurService',
    component: OurService,
    children: ourServiceRoutes
  },
  {
    path: '/about-us',
    name: 'Aboutus',
    component: Aboutus,
    children: aboutUsRoutes
  },
  {
    path: '/paxelin-club',
    name: 'PaxelinClub',
    component: PaxelinClub,
    children: PaxelinClubRoutes
  },
  {
    path: '/paxel-market',
    name: 'PaxelinMarket',
    component: PaxelinMarket,
    children: PaxelinMarketRoutes
  },
  {
    path: '/mitra-paxel',
    name: 'MitraPaxel',
    component: MitraPaxel,
    children: MitraPaxelRoutes
  },
  {
    path: '/paxel-big',
    name: 'PaxelBig',
    component: PaxelBig,
    children: PaxelBigRoutes
  },
  {
    path: '/corp-sales',
    name: 'corpSales',
    component: corpSales,
    children: CorpSalesRoutes
  },
  {
    path: '/locker',
    name: 'Locker',
    component: Locker,
    children: LockerRoutes
  },
  {
    path: '/tnc',
    name: 'Tnc',
    component: Tnc,
    children: TncRoutes
  },
  {
    path: '/paxelco-dashboard',
    name: 'PaxelcoDashboard',
    component: PaxelcoDashboard,
  },
  {
    path: '/footnote',
    name: 'footNote',
    component: footNote,
  },
  {
    path: '/captcha',
    name: 'Captcha',
    component: Captcha,
  },
  {
    path: '/create-captcha',
    name: 'createCaptcha',
    component: createCaptcha,
  },
  {
    path: '/edit-captcha/:id',
    name: 'editCaptcha',
    component: editCaptcha,
  },
  // {
  //   path: '/product-master',
  //   name: 'ProductMaster',
  //   component: ProductMaster,
  // },
  // {
  //   path: '/create-product-master',
  //   name: 'createProductMaster',
  //   component: createProductMaster,
  // },
  // {
  //   path: '/edit-product-master/:id',
  //   name: 'editProductMaster',
  //   component: editProductMaster,
  // },
  // {
  //   path: '/category-product',
  //   name: 'CategoryProduct',
  //   component: CategoryProduct,
  // },
  // {
  //   path: '/create-category-product',
  //   name: 'createCategory',
  //   component: createCategory,
  // },
  // {
  //   path: '/edit-category-product/:id',
  //   name: 'editCategory',
  //   component: editCategory,
  // },
  // {
  //   path: '/sub-category-product',
  //   name: 'SubCategoryProduct',
  //   component: SubCategoryProduct,
  // },
  // {
  //   path: '/create-sub-category-product',
  //   name: 'createSubCategory',
  //   component: createSubCategory,
  // },
  // {
  //   path: '/edit-sub-category-product/:id',
  //   name: 'editSubCategory',
  //   component: editSubCategory,
  // },
  {
    path: '/home-page',
    name: 'homePage',
    component: homePage,
  },
  {
    path: '/create-home-page',
    name: 'createHomePage',
    component: createHomePage,
  },
  {
    path: '/edit-home-page/:id',
    name: 'editHomePage',
    component: editHomePage,
  },
  {
    path: '/article',
    name: 'Article',
    component: Article,
  },
  {
    path: '/create-article',
    name: 'createArticle',
    component: createArticleNew,
  },
  {
    path: '/edit-article/:id',
    name: 'editArticle',
    component: editArticleNew,
  },
  {
    path: '/preview-article',
    name: 'previewArticle',
    component: previewArticle
  },
  {
    path: '/click2buy',
    name: 'Click2buy',
    component: Click2buy,
  },
  {
    path: '/form-click2buy/:proses/:id',
    name: 'formClick2buy',
    component: formClick2buy,
  },
  {
    path: '/faq-category',
    name: 'FaqCategory',
    component: FaqCategory,
  },
  {
    path: '/faq-content',
    name: 'FaqContent',
    component: FaqContent,
  },
  {
    path: '/create-faq-category',
    name: 'createFaqCategory',
    component: createFaqCategory,
  },
  {
    path: '/edit-faq-category/:id',
    name: 'editFaqCategory',
    component: editFaqCategory,
  },
  {
    path: '/create-faq',
    name: 'createFaq',
    component: createFaq,
  },
  {
    path: '/edit-faq/:id',
    name: 'editFaq',
    component: editFaq,
  },
  {
    path: '/privacy-policy',
    name: 'Privacypolicy',
    component: Privacypolicy,
  },
  {
    path: '/create-privacy-policy',
    name: 'createPrivacypolicy',
    component: createPrivacypolicy,
  },
  {
    path: '/edit-privacy-policy/:id',
    name: 'editPrivacypolicy',
    component: editPrivacypolicy,
  },
  {
    path: '/new-user-promo',
    name: 'newUserPromo',
    component: newUserPromo,
  },
  {
    path: '/create-new-user-promo',
    name: 'createnewUserPromo',
    component: createnewUserPromo,
  },
  {
    path: '/edit-new-user-promo/:id',
    name: 'editnewUserPromo',
    component: editnewUserPromo,
  },
  {
    path: '/on-boarding-screen',
    name: 'onBoardingScreen',
    component: onBoardingScreen,
  },
  {
    path: '/create-on-boarding-screen',
    name: 'createonBoardingScreen',
    component: createonBoardingScreen,
  },
  {
    path: '/edit-on-boarding-screen/:id',
    name: 'editonBoardingScreen',
    component: editonBoardingScreen,
  },
  {
    path: '/general-enable-disable-feature',
    name: 'GeneralEnableDisableFeature',
    component: GeneralEnableDisableFeature,
  },
  {
    path: '/create-general-enable-disable-feature',
    name: 'createGeneralEnableDisableFeature',
    component: createGeneralEnableDisableFeature,
  },
  {
    path: '/edit-general-enable-disable-feature/:id',
    name: 'editGeneralEnableDisableFeature',
    component: editGeneralEnableDisableFeature,
  },
  {
    path: '/general-contact-us',
    name: 'GeneralContactUs',
    component: GeneralContactUs,
  },
  {
    path: '/create-general-contact-us',
    name: 'createGeneralContactUs',
    component: createGeneralContactUs,
  },
  {
    path: '/edit-general-contact-us/:id',
    name: 'editGeneralContactUs',
    component: editGeneralContactUs,
  },
  {
    path: '/general-new-user-promo',
    name: 'GeneralNewUserPromo',
    component: GeneralNewUserPromo,
  },
  {
    path: '/create-general-new-user-promo',
    name: 'createGeneralNewUserPromo',
    component: createGeneralNewUserPromo,
  },
  {
    path: '/edit-general-new-user-promo/:id',
    name: 'editGeneralNewUserPromo',
    component: editGeneralNewUserPromo,
  },
  {
    path: '/report-refferal',
    name: 'ReportRefferal',
    component: ReportRefferal,
  },
  {
    path: '/show-case',
    name: 'ShowCase',
    component: ShowCase,
  },
  {
    path: '/create-show-case',
    name: 'createShowCase',
    component: createShowCase,
  },
  {
    path: '/edit-show-case/:id',
    name: 'editShowCase',
    component: editShowCase,
  },
  {
    path: '/donasi',
    name: 'Donasi',
    component: Donasi,
  },
  {
    path: '/create-donasi',
    name: 'createDonasi',
    component: createDonasi,
  },
  {
    path: '/edit-donasi/:id',
    name: 'editDonasi',
    component: editDonasi,
  },
  {
    path: '/report-rating',
    name: 'ReportRating',
    component: ReportRating,
  },
  {
    path: '/rate',
    name: 'Rate',
    component: Rate,
  },
  {
    path: '/create-rate',
    name: 'createRate',
    component: createRate,
  },
  {
    path: '/edit-rate/:id',
    name: 'editRate',
    component: editRate,
  },
  {
    path: '/reason',
    name: 'Reason',
    component: Reason,
  },
  {
    path: '/create-reason',
    name: 'createReason',
    component: createReason,
  },
  {
    path: '/edit-reason/:id',
    name: 'editReason',
    component: editReason,
  },
  {
    path: '/extra-packaging',
    name: 'ExtraPackaging',
    component: ExtraPackaging,
  },
  {
    path: '/create-extra-packaging',
    name: 'createExtraPackaging',
    component: createExtraPackaging,
  },
  {
    path: '/edit-extra-packaging/:id',
    name: 'editExtraPackaging',
    component: editExtraPackaging,
  },
  {
    path: '/refferal-partner',
    name: 'refferalPartner',
    component: refferalPartner,
  },
  {
    path: '/create-refferal-partner',
    name: 'createrefferalPartner',
    component: createrefferalPartner,
  },
  {
    path: '/edit-refferal-partner/:id',
    name: 'editrefferalPartner',
    component: editrefferalPartner,
  },
  {
    path: '/download',
    name: 'Download',
    component: Download,
    children: downloadRoutes,
  },
  {
    path: '/paxel-recycle',
    name: 'PaxelRecycle',
    component: PaxelRecycle,
    children: PaxelRecycleRoutes
  },
  {
    path: '/pejuang-online',
    name: 'PejuangOnline',
    component: PejuangOnline,
    children: PejuangOnlineRoutes
  },
  {
    path: '/global-search',
    name: 'GlobalSearch',
    component: GlobalSearch,
  },
  {
    path: '/create-global-search',
    name: 'createGlobalSearch',
    component: createGlobalSearch,
  },
  {
    path: '/edit-global-search/:id',
    name: 'editGlobalSearch',
    component: editGlobalSearch,
  },
  {
    path: '/promo',
    name: 'Promo',
    component: Promo,
    children: PromoRoutes
  },
];

export default marketingRoutes;
